import SwiperClass from "swiper";
import { nextTick } from "vue";

export default (options, inject) => {
  const swiperInstances = new Map();
  const { app } = options;
  const createSwiper = (className, swiperOptions) => {
    const instance = new SwiperClass(className, swiperOptions);
    swiperInstances.set(className, instance);
    return instance;
  };

  inject("swiper", {
    async init(className, swiperOptions) {
      await app.$cookieConsent.waitForCookiebotLoad();

      await nextTick();

      if (!document.querySelector(className)) {
        return null;
      }

      return createSwiper(className, swiperOptions);
    },

    destroy(className) {
      const instance = swiperInstances.get(className);
      if (instance) {
        instance.destroy?.();
        swiperInstances.delete(className);
      }
    },
  });
};
